module.exports = "<div class=\"col-12 py-0 pt-3 py-md-3\">\n  <h5><%= category %><span class=\"resultsCount ml-1 d-none\"> (<%= resultCount %>)</span></h5>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/static/js/views/category.tpl.html
// module id = QU1z
// module chunks = 5